export const CONCILIATION_INITIALSTATE = {
    conciliation: [],
};
export const CONCILIATION_SETCONCILIATION = 'CONCILIATION_SETCONCILIATION';
export const CONCILIATION_ONCHANGETABLE = 'CONCILIATION_ONCHANGETABLE';
export const CONCILIATION_RESET = 'CONCILIATION_RESET';